module.exports = __webpack_public_path__ + "static/media/image 7.4439f5a6.png";